import React, { memo } from 'react'
import { faQrcode } from '@fortawesome/pro-duotone-svg-icons'
import QrReader from 'react-qr-reader'
import styled from '@emotion/styled'

import Popup from '../popup/Popup'
import {
  CSS_FULL_HEIGHT,
  CSS_FULL_WIDTH
} from '../../../libs/qb-brand-web-components'

const ScanQrCode = ({ onScan, onError, ...restProps }) => {
  return (
    <Popup icon={faQrcode} {...restProps}>
      <QrCodeContainer
        onError={onError}
        onScan={onScan}
        facingMode='environment'
        delay={300}
      />
    </Popup>
  )
}

export default memo(ScanQrCode)

const QrCodeContainer = styled(QrReader)`
  height: 270px;
  width: 270px;
  margin-left: auto;
  margin-right: auto;
  div {
    border: none !important;
    box-shadow: none !important;
  }
  video {
    ${CSS_FULL_HEIGHT};
    ${CSS_FULL_WIDTH};
    object-fit: cover !important;
    border: 2px solid;
    border-radius: 10px;
  }
`
